import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.itineraries')
  .service('ItinerariesAPI', ItinerariesAPI);

function ItinerariesAPI(): BringozApi {
  return {
    base: `/itineraries`,
    infiniteScroll: {
      address: `/itineraries`,
      cmd: 'GET'
    },
    actions: {
      getItineraries: {
        address: '',
        cmd: 'GET',
        updateable: true
      }
    }
  }
}
